import {Dialog} from '@base-ui/react/dialog';
import {type ReactNode, useEffect} from 'react';

import useMenuVisibility from '@/hooks/useMenuVisibility';

type DialogBaseProps = {
    open: boolean;
    onOpenChange?: (open: boolean) => void;
    onOpenChangeComplete?: (open: boolean) => void;
    children: ReactNode;
    modal?: boolean;
};

const DialogBase = ({open, onOpenChange, onOpenChangeComplete, children, modal = true}: DialogBaseProps) => {
    const {hideMenu, showMenu} = useMenuVisibility();

    useEffect(() => {
        if (open) {
            hideMenu();
        } else {
            showMenu();
        }
    }, [open, hideMenu, showMenu]);

    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange} onOpenChangeComplete={onOpenChangeComplete} modal={modal}>
            <Dialog.Portal>{children}</Dialog.Portal>
        </Dialog.Root>
    );
};

export default DialogBase;
